import { useMutation, useQueryClient } from "@tanstack/react-query";
import { post, postFormData } from "~/Services/Request";

export const usePostModel = <TModel, TResponse = TModel>(segment: string) => {
    const queryClient = useQueryClient();
    const { displayError } = useErrorHandler();
    return useMutation<TResponse, any, TModel, any>({
        mutationFn: async model => {
            return await PostModel<TModel, TResponse>(model, segment);
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({ queryKey: [segment] });
        },
        onError: (error, variables, context) => {
            displayError(error);
        },
    });
};
export const usePostFormData = (segment: string) => {
    const queryClient = useQueryClient();
    const { displayError } = useErrorHandler();
    return useMutation({
        mutationFn: async (model: FormData) => {
            return await PostFormData(model, segment);
        },
        onSettled: async () => {
            await queryClient.invalidateQueries({ queryKey: [segment] });
        },
        onError: (error, variables, context) => {
            displayError(error);
        },
    });
};

const PostModel = <TModel, TResponse = TModel>(model: TModel, segment: string) => {
    let endpoint = "/api/v1/admin/" + segment;
    return post<TResponse>(endpoint, model);
};

const PostFormData = (model: FormData, segment: string) => {
    let endpoint = "/api/v1/admin/" + segment;
    return postFormData(endpoint, model);
};

function useErrorHandler() {
    return {
        displayError: (error: any) => {
            console.log(error);
        },
    };
}
